export const translations = {
  en: {
    my_orders: "My Orders",
    placed: "Placed",
    paid_on: "Paid on",
    payment_failed: "Online: Payment Failed",
    retry: "Retry Payment",
    status_pending: "Pending",
    orders: "My Orders",
    place_order: "Place Order",
    total: "Total Amount",
    item: "Item",
    items: "Items",
    // add more keys here...
  },
  hi: {
    my_orders: "मेरे आदेश",
    placed: "ऑर्डर दिया गया",
    paid_on: "भुगतान किया गया",
    "Paid on": "भुगतान तिथि ",
    payment_failed: "ऑनलाइन: भुगतान विफल",
    "Payment Failed": "भुगतान विफल",
    retry: "पुनः भुगतान प्रयास करें",
    status_pending: "पेंडिंग",
    "New Order": "नया ऑर्डर",
    ALL: "सभी",
    orders: "मेरे ऑर्डर",
    place_order: "ऑर्डर दें",
    total: "कुल राशि",
    Dashboard: "मुख्य पृष्ठ",
    // Products :"उत्पाद",
    Orders: "ऑर्डर",
    Cart: "कार्ट",
    Addresses: "पते",
    Profile: "विवरण",
    "Add Product": "उत्पाद जोड़ें",
    Area: "क्षेत्र",
    "Orders List": "ऑर्डर सूची",
    "Orders History": "ऑर्डर का इतिहास",
    "Search orders or items...": "ऑर्डर या सामग्रियों खोजें...",
    Hi: "हैलो",
    Hello: "हैलो",
    Logout: "बाहर निकलें",
    Items: "सामग्रि",
    Item: "सामग्रि",

    "Placed On ": "ऑर्डर तारीख ",
    MAY: " मई ",
    "Order Summary": "ऑर्डर विवरण",
    "Hello! I need help with my order.": "ऑर्डर से जुड़ी सहायता",
    "Preparing your dashboard...": "आपका डैशबोर्ड तैयार किया जा रहा है...",
    "Oops! Something went wrong": "उफ़! कुछ गड़बड़ हो गई है",
    "Items added to cart! Redirecting...":
    "सामान कार्ट में जोड़ दिया गया है!...",
    "Manage your orders and account settings":
      "अपने ऑर्डर और खाता सेटिंग्स प्रबंधित करें",
    "Total Spent": "कुल खर्च",
    "Edit Details": "विवरण बदलें",
    "Shop Now": "अभी खरीदें",
    "Need Help": "मदद चाहिए",
    "Facing issues with your delivery or payment":
    "क्या आपको अपनी डिलीवरी या भुगतान में कोई समस्या आ रही है",
    "Chat with Support": "सहायता टीम से चैट करें",
    "Call Support": "सहायता टीम को कॉल करें ",
    "Active Orders": "सक्रिय ऑर्डर",
    Running: "सक्रिय",
    "Phone Number": "मोबाइल नंबर",
    "Phone":"मोबाइल नंबर",
    "Recent Orders": "हाल के ऑर्डर",
    "View History": "इतिहास देखें",
    "Fetching your orders": "आपके ऑर्डर प्राप्त किए जा रहे हैं",
    "No orders yet.": "अभी तक कोई ऑर्डर नहीं है।",
    "more items": "और आइटम",
    "Re-order": "फिर ऑर्डर करें",
    "RE-ORDER": "फिर ऑर्डर करें",
    Track: "स्थिति देखें ",
    Products: "सामान",
    "Search snacks, drinks...": "स्नैक्स, ड्रिंक्स खोजें...",
    Newest: "नवीनतम",
    "Price: Low → High": "कीमत: कम से अधिक",
    "Price: High → Low": "कीमत: अधिक से कम",
    "In Stock": "उपलब्ध है",
    "Out of Stock": "उपलब्ध नहीं",
    "Sold Out": "बिक चुका",
    "SOLD OUT": "बिक चुका",
    Only: "सिर्फ",
    left: "बचा",
    ADD: "जोड़ें",
    "Fetching fresh items": "ताज़ा आइटम लोड हो रहे हैं",
    Prev: "पिछला",
    Next: "अगला",
    "View Cart": "कार्ट देखें",
    "Delivery Address": "डिलीवरी का पता",
    "Total Paid": "कुल भुगतान",
    Paid: "चुकाया",
    Pending: "लंबित",
    Invoice: "बिल",
    "Online: Payment Failed": "ऑनलाइन: भुगतान विफल",
    Qty: "मात्रा",
    "RATE ORDER": "रेटिंग दें",
    "rate-item": "रेट-आइटम",
    "Retry Payment": "दोबारा प्रयास",
    "Your Basket": "आपकी टोकरी",
    "Add More": "और जोड़ें",
    "Your cart is feeling light": "आपका कार्ट काफी हल्का लग रहा है...",
    "Start Shopping": "खरीदारी शुरू करें",
    "Forgot something? Add more items": "कुछ भूल गए क्या? और सामान जोड़ें",
    "per unit": "प्रति यूनिट",
    "Add New": "नया जोड़ें",
    "Bill Details": "भुगतान का विवरण",
    "Item Total": "आइटम कुल",
    "Delivery Fee": "डिलीवरी शुल्क",
    "Checking pincode serviceability...":
    "पिनकोड की उपलब्धता जांची जा रही है...",
    "Grand Total": "कुल योग",
    "Choose Payment Method": "भुगतान की विधि चुनें",
    "Cash on Delivery": "नकद भुगतान",
    "Online Payment": "ऑनलाइन पेमेंट",
    "Fast & Secure": "तेज़ और सुरक्षित",
    "Secure by Razorpay": "रेज़रपे द्वारा सुरक्षित",
    "PROCESSING...":"प्रक्रिया चालू है...",
    "PAY & PLACE ORDER":"भुगतान और ऑर्डर करें",
    "CONFIRM ORDER":"ऑर्डर की पुष्टि करें",
    "We don't deliver to":"हम अभी इस",
    "yet":"में डिलीवरी नहीं करते हैं",
    // "FREE":"निःशुल्क",
    "FREE":"मुफ़्त",
    "Address Book":"पता पुस्तिका",
    "Manage delivery locations":"डिलीवरी के पते प्रबंधित करें",
    "Loading Addresses":"आपके पते ढूंढे जा रहे हैं...",
    "Checking pincode serviceability":"पिनकोड की उपलब्धता जांची जा रही है",
    "EDIT":"बदलें",
    "DEFAULT":"प्राथमिक",
    "DELETE":"मिटाएं",
    "Default":"प्राथमिक",
    "Use Interactive Map to Pin Location":"मैप पर अपनी लोकेशन पिन करें",
    "Move pin to your doorstep":"पिन को अपने घर के दरवाज़े पर लगाएं",
    "CHECK":"जांचें",
    "Didn't get the code":"कोड नहीं मिला",
    "RESEND NOW":"दोबारा भेजें",
    "RESEND IN":"दोबारा भेजें",
     "Address Label":"पते का प्रकार",
     "Receiver's Name":"प्राप्तकर्ता का नाम",
     "VERIFY":"सत्यापित करें",
     "Verified":"सत्यापित",
     "Account Details":"खाते का विवरण",
     "Full Name":"पूरा नाम",
     "Email":"ईमेल",
     "Cancel":"रद्द करें",
     "Logout Account":"खाते से बाहर निकलें",
     "Manage Addresses":"पते प्रबंधित करें",
     "House No., Building, Street Name...":"भवन/मकान संख्या, इमारत, गली/सड़क का नाम...",
     "Pincode":"पिनकोड",
     "City":"शहर",
     "State":"राज्य",
     "Save Location":"पता सुरक्षित करें",
     "Loading Account...":"खाता लोड हो रहा है...",
     "Save Profile":"प्रोफाइल सेव करें"
  },
};
